//@flow
import React from 'react';
import { PrismicGrantItem } from '../../types/prismic';
import styles from './grants.module.scss';
import { Carousel } from '../base';
import GrantBlock from './GrantBlock';

type Props = {
  grants: PrismicGrantItem[];
};

const ChildGrantBlock = (item: PrismicGrantItem, index, isTouch) => {
  return (
    <GrantBlock key={`${index}`} id={item.id} item={item} isTouch={isTouch} />
  );
};

const Grants = ({ grants }: Props) => {
  return (
    <section className="full-width no-overflow center">
      <div className={`inner-width inner-width-padding-bottom`}>
        <Carousel
          categories={grants}
          childBlock={ChildGrantBlock}
          externalClassName={styles.wrapper}
        />
      </div>
    </section>
  );
};

export default Grants;
